import $ from "jquery";
import Functions from './functions';
import {urlForKuwait, urlPaymentTranslate} from "./config";

export let type = 'eng';

export default {
  // example
  // translate() {
  //   this.getTranslate(null, urlForRamadan);
  // },

  translatePayment() {
    this.getTranslate(null, urlPaymentTranslate);
    if (type === 'eng') {
      document.title = '';
    } else if (type === 'ar') {
      document.title = '';
    }
  },

  translateKuwait() {
    this.getTranslate(null, urlForKuwait);
    if (type === 'eng') {
      document.title = '';
    } else if (type === 'ar') {
      document.title = '';
    }
  },

  getTranslate(lang = null, url) {
    let newUrl = '';
    let newPathUrl = Functions.getParameterByName('lang');
    if (window.location.search === '') {
      newUrl = '?';
    } else {
      newUrl = '&';
    }

    if ($('.language-selector__item--selected').hasClass('language-selector__item-ae')) {
      type = 'ar';
      $('body').addClass('body-ar').css('direction', 'rtl');

      if (newPathUrl === null) {
        window.history.replaceState(null, null, window.location.href + newUrl + 'lang=ar');
      } else {
        window.history.replaceState(null, null, window.location.href.replace('lang=eng', 'lang=ar'));
      }
    } else {
      type = 'eng';
      $('body').removeClass('body-ar').css('direction', 'ltr');
      if (newPathUrl === null) {
        window.history.replaceState(null, null, window.location.href + newUrl + 'lang=eng');
      } else {
        window.history.replaceState(null, null, window.location.href.replace('lang=ar', 'lang=eng'));
      }
    }

    let languages = {
      'eng': 'English',
      'ar': 'Arabic',
    };
    $('input[name="language-type"]').attr('value', languages[type]);

    $.ajax({
      type: "GET",
      url: url,
      data: {lang: type, action: 'change'},
      beforeSend: function () {
        $('.loader').css('display', 'flex').fadeIn();
      },
      complete: function () {
        setTimeout(function () {
          $('.loader').fadeOut();
        }, 500);
      },
      success: function (msg) {
        let result = JSON.parse(msg);
        let selector = '';

        if (result.inputs) {
          Object.keys(result.inputs).forEach(function (e) {
            selector = ("." + e);
            $(selector).val(result.inputs[e]);
          });

          delete result.inputs;
        }

        if (result.placeholders) {
          Object.keys(result.placeholders).forEach(function (e) {
            selector = ("." + e);
            $(selector).attr("placeholder", result.placeholders[e]);
          });

          delete result.placeholders;
        }

        if (result['section-transform__images']) {
          Object.keys(result['section-transform__images']).forEach(function (e) {
            selector = ("." + e);
            $(selector).attr("src", result['section-transform__images'][e]);
          });

          delete result['section-transform__images'];
        }

        Object.keys(result).forEach(function (e) {
          selector = ("." + e);
          $(selector).html(result[e]);
        });
      }
    });
  },
}
